module.exports = __webpack_public_path__ + "static/media/3.13_preview.be6575ba.png";